import { MenuItem, Select } from '@mui/material'
import React from 'react'

import { POLICY_CATEGORY_OPTIONS } from 'components/test-suites/forms/test-suite-form-utils'

import type { FieldValues } from 'react-hook-form'
import type { FieldPath } from 'react-hook-form/dist/types'
import type {
  ControllerFieldState,
  ControllerRenderProps
} from 'react-hook-form/dist/types/controller'

type TestSuitePolicyCategorySelectProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>
> = {
  field: ControllerRenderProps<TFieldValues, TName>
  fieldState: ControllerFieldState
}

export const TestSuitePolicyCategorySelect = <
  TFieldName extends FieldValues,
  TName extends FieldPath<TFieldName>
>({
  field,
  fieldState
}: TestSuitePolicyCategorySelectProps<TFieldName, TName>) => {
  return (
    <Select
      {...field}
      data-testid="test-suite-scenario-details-policy-category"
      error={Boolean(fieldState.error)}
    >
      {POLICY_CATEGORY_OPTIONS.map((policyCategoryOption) => (
        <MenuItem
          key={policyCategoryOption.value}
          data-testid={`test-suite-scenario-details-policy-category-menu-item-${policyCategoryOption.value}`}
          value={policyCategoryOption.value}
        >
          {policyCategoryOption.label}
        </MenuItem>
      ))}
    </Select>
  )
}
